<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Q8 Fuel on the Go"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-message-header
        icon="warning"
        text="Je hebt niet voldoende geld op je rekening"
        :error="true"
      />
      <o-section>
        <p>
          Je moet minstens 5 euro op je voorkeursrekening hebben staan om te
          kunnen tanken. Zuiver je rekening eerst aan.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Sluiten" to="/sales/fuel/" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'

export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OMessageHeader,
    OPayButton
  },
  data() {
    return {}
  }
}
</script>
